import styled from "@emotion/styled";

import { StyledImage as AuthorAvatarImage } from "~/components/author/author-avatar/styles";
import { AuthorName } from "~/components/author/author-name";
import { AuthorSocialLinks } from "~/components/author/author-social-links";
import { EntityFollowButton } from "~/components/entity-follow-button";

export const AuthorCardContainer = styled.div`
  display: grid;
  grid:
    "avatar . header-bar ." min-content
    "avatar . . ." 8px
    "avatar . name ." min-content
    "avatar . . ." 16px
    "avatar . follow-button ." min-content
    "avatar . . ." 12px
    "avatar . bio ." min-content
    "avatar . social ." min-content
    / min-content 12px auto 5px;

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "avatar . header-bar ." min-content
      "avatar . . ." 8px
      "avatar . name ." min-content
      "avatar . . ." 16px
      "avatar . follow-button ." min-content
      "avatar . . ." 12px
      "avatar . bio ." min-content
      "avatar . social ." min-content
      / min-content 20px auto 5px;
  }
`;

export const AvatarContainer = styled.div`
  grid-area: avatar;

  ${AuthorAvatarImage} {
    inline-size: 70px;
    block-size: 70px;
  }
  ${props => props.theme.breakpoints.up("tablet")} {
    ${AuthorAvatarImage} {
      inline-size: 100px;
      block-size: 100px;
    }
  }
`;

export const HeaderBarContainer = styled.div`
  grid-area: header-bar;
`;

export const FollowButtonContainer = styled.div`
  grid-area: follow-button;
`;

export const StyledEntityFollowButton = styled(EntityFollowButton)``;

export const NameContainer = styled.div`
  grid-area: name;

  font-weight: 700;
`;

export const StyledAuthorName = styled(AuthorName)`
  line-height: 16px;
`;

export const BioContainer = styled.div`
  grid-area: bio;
`;

export const SocialLinksContainer = styled.div`
  grid-area: social;
`;

export const StyledAuthorSocialLinks = styled(AuthorSocialLinks)`
  margin-block-start: 12px;
`;
